import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/Icon";
import { COMPANY } from "@/lib/data";

export function CTABanner() {
  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-brand-purple noise-overlay px-8 py-12 sm:px-14 sm:py-16">
          <div className="relative z-10 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div>
              <h2 className="font-heading text-2xl font-bold text-white sm:text-3xl">Ready to schedule reliable transportation?</h2>
              <p className="mt-3 max-w-xl text-purple-100">
                Request a ride online or call our team directly. We're here to help you get where you need to go, safely.
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link to="/book-a-ride">
                <Button data-testid="cta-book-ride" className="h-13 rounded-full bg-white px-7 py-3 text-base font-semibold text-brand-purple hover:bg-slate-100">
                  Book a Ride
                </Button>
              </Link>
              <a href={COMPANY.phoneHref}>
                <Button data-testid="cta-call" variant="outline" className="h-13 rounded-full border-2 border-white bg-transparent px-7 py-3 text-base font-semibold text-white hover:bg-white/10">
                  <Icon name="Phone" size={18} weight="fill" className="mr-2" /> {COMPANY.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
